import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useSite } from "../../context/SiteContext";
import { Reveal, Overline } from "../Reveal";

export default function Manifesto() {
    const { site, tx } = useSite();
    const c = site?.content || {};
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const stretch = useTransform(scrollYProgress, [0.1, 0.9], [1, 1.45]);
    const drift = useTransform(scrollYProgress, [0, 1], [60, -60]);

    return (
        <section ref={ref} id="manifesto" data-testid="manifesto-section" className="grain relative overflow-hidden bg-[#F4F3EF] px-6 py-32 text-[#0A0A0A] md:px-12 md:py-48 lg:px-24">
            <div className="grid gap-16 md:grid-cols-12">
                <div className="md:col-span-7">
                    <div className="md:sticky md:top-32">
                        <Overline testId="manifesto-overline">Manifesto — 01</Overline>
                        <motion.h2
                            style={{ scaleX: stretch }}
                            data-testid="manifesto-line1"
                            className="font-display mt-6 origin-left text-[clamp(4rem,11vw,10rem)] leading-[0.85] tracking-tight"
                        >
                            {tx(c.manifesto_line1) || "THE FIELD"}
                        </motion.h2>
                    </div>
                </div>
                <motion.div style={{ y: drift }} className="flex flex-col justify-center md:col-span-5">
                    <Reveal>
                        <h3 className="font-display text-[clamp(3rem,7vw,6rem)] leading-[0.85] text-[#D60024]">
                            {tx(c.manifesto_line2) || "IS JUST"}
                        </h3>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h3 className="font-display text-[clamp(3rem,7vw,6rem)] leading-[0.85]">
                            {tx(c.manifesto_line3) || "THE START."}
                        </h3>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p data-testid="manifesto-text" className="mt-10 max-w-md text-base leading-relaxed text-black/70">
                            {tx(c.manifesto_text)}
                        </p>
                    </Reveal>
                </motion.div>
            </div>
        </section>
    );
}
